import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceProducts(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_FINANCE_PRODUCTS,
		ModulesConfigMap[ModulesMap.REPORTS_FINANCE_PRODUCTS].GET_REPORTS_FINANCE_PRODUCTS,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_PRODUCTS].GET_REPORTS_FINANCE_PRODUCTS]: _getReportsFinanceProducts,
}